import type { NextPage } from 'next';
import dynamic from 'next/dynamic';
import React from 'react';

import PageNextJs from 'nextjs/PageNextJs';

const PrioritySupport = dynamic(() => import('ui/pages/PrioritySupport'), { ssr: false });

const Page: NextPage = () => {
  return (
    <PageNextJs pathname="/priority-support">
      <PrioritySupport/>
    </PageNextJs>
  );
};

export default Page;
